module.exports = __webpack_public_path__ + "img/4.825ee985.png";